<template>
  <div id="Index-page" class="centered text-primary text-center">
    <h1>Intended Me</h1>
    <p>
        Forget all that you know or think you know. Take all your beliefs off the table and put them in a bag and set it aside.
        The courses on this site will challenge you to make up your mind about what you believe. By the end of the courses, you
        may end up with a few new beliefs. New or not, the beliefs you decided on are now on the table. Now, grab that bag of beliefs
        you set aside earlier and begin taking your beliefs out of the bag one by one. As you take out each belief, examine it
        and decide if it fits with the rest of your beliefs that are already on the table. If it fits, put it back on the table.
        If it doesn't fit, throw it away.
    </p>
    <h2 class="mt-5">
      <font-awesome-icon class="loading" icon="gear" /><br>
      Coming Soon!
    </h2>
    <p v-if="false">The site is coming New Year's Day</p>
    <MailingListForm></MailingListForm>
  </div>
</template>

<script>
import MailingListForm from "@/Modules/MailingLists/Components/MailingListEmail_Form";

export default {
    components: {
        MailingListForm
    }
};
</script>
<style lang="scss">
#Index-page {
  h1 { font-weight: 700; }
  .full-page > .content {
    min-height: calc(100vh - 160px);
  }
  .not-found-icon {
    margin-right: 10px;
  }
  &.centered {
    h1,
    i {
      font-size: 50px;
    }
    p {
      font-size: 20px;
    }
    display: flex;
    min-height: calc(100vh - 310px);
    //padding-bottom: 150px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .loading { animation: rotate-loading 2s infinite linear; }
}
</style>
